import { Link, useNavigate } from 'react-router-dom';
import { ImageContainer } from '../../constants/ImagesConstants';
import { Config } from '../../config/Config';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import LanguageSwitcher from './LanguageSwitcher';

const Header = ({ payload }: any) => {
  const { name, email, image } = payload;
  const navigate = useNavigate()

  const profile_data = useSelector((state: any) => state.GetProfileState);

  if (Config?.USER_DETAILS?.is_profile_setup == 2 && Config?.USER_DETAILS?.is_approved == 2) {
    navigate("/")
  }
  else if (Config?.USER_DETAILS?.is_profile_setup == 2 && Config?.USER_DETAILS?.is_approved == 3) {
    navigate("/")
  } else if (Config?.USER_DETAILS?.is_profile_setup == 2 && Config?.USER_DETAILS?.is_approved == 0) {
    navigate("/");
  }

  return (
    <>

      <nav className="navbar navbar-expand-lg bg-white">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/dashboard"><img src={ImageContainer?.Logo} /></Link>
          {/* <Link className="navbar-brand" to="/"><img src={ImageContainer?.Logo} /></Link> */}
          <div className='loginUser'>
            <LanguageSwitcher className="me-2 me-lg-3" variant="dark" />
            <div className="dropdown">
              <button className="p-0 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <figure><img src={image || profile_data?.data?.data?.profile_pic} onError={(e: any) => e.target.src = ImageContainer?.ProfileDetailIconImage} /></figure>
                <div className='userINfo d-none d-md-block'>
                  <p><b>{name || profile_data?.data?.data?.owner_name}</b></p>
                  <p>{email}</p>
                </div>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                {/* {Config?.USER_DETAILS?.is_approved == 1 && <li> <Link className="dropdown-item" to="/dashboard">Dashboard</Link></li>} */}
                {
                  Config?.USER_DETAILS?.is_approved == 1 && Config.USER_DETAILS?.role_id == 1 && <li><Link className="dropdown-item" to="/my-profile"><FormattedMessage id="my_profile" /></Link></li>
                }
                {Config?.USER_DETAILS?.is_approved == 1 && <li><Link className="dropdown-item" to="/change-password"><FormattedMessage id="change_password" /></Link></li>}
                <li><Link className="dropdown-item" to="/about-us"><FormattedMessage id="about" /></Link></li>
                <li><Link className="dropdown-item" to="/terms-and-conditions"><FormattedMessage id="terms_and_condition" /></Link></li>
                <li><Link className="dropdown-item" to="/privacy-policy"><FormattedMessage id="privacy_policy" /></Link></li>
                <li><Link className="dropdown-item" to="/cancellation-policy"><FormattedMessage id="cancellation-policy" /></Link></li>
                <li><Link className="dropdown-item" to="/faqs"><FormattedMessage id="faqs" /></Link></li>
                {/* <li><Link className="dropdown-item" to="/faq">FAQ's</Link></li> */}
              </ul>
            </div>
            <div className=' ms-2 ms-lg-5'>
              <Link to="/notifications" className='notification'>
                <i className="icon-notification"></i>
                <span className='dots'></span>
              </Link>
              {/* <Link to="/notifications" className='notification'>
                <i className="icon-notification"></i>
                <span className='dots'></span>
              </Link> */}
            </div>
          </div>
        </div>
      </nav >



    </>
  );
};

export default Header;